import _ from 'lodash'
import { AutoComplete } from 'primereact/autocomplete'
import { InputText } from 'primereact/inputtext'
import { useState } from 'react'

import { FC } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const noShowFields1a10 = false
const language = cap.language.state || 'IT'
const t = translations[language]

const fieldMap = [
  { id: 'mastro', label: t.mastro, maxLength: 2 },
  { id: 'gruppo', label: t.gruppo, maxLength: 2 },
  { id: 'conto', label: t.conto, maxLength: 2 },
  { id: 'sottoConto', label: t.sottoConto, maxLength: 6 }
]

/**
 * Formatta il codice cliente dividendo il codCliente12 nelle sue componenti
 * @param {string} codCliente12 - Codice cliente a 12 cifre
 * @returns {Object} Oggetto con le componenti del codice cliente
 */
const formatClientCode = (codCliente12) => {
  if (!codCliente12) return {}

  return {
    mastro: codCliente12.slice(0, 2),
    gruppo: codCliente12.slice(2, 4),
    conto: codCliente12.slice(4, 6),
    sottoConto: codCliente12.slice(6, 12)
  }
}

/**
 * Crea il label formattato per la visualizzazione del cliente
 * @param {string} ragioneSociale - Ragione sociale del cliente
 * @param {string} codCliente12 - Codice cliente a 12 cifre
 * @returns {string} Label formattato con ragione sociale e codice cliente
 */
const createClientLabel = (ragioneSociale, codCliente12) => {
  if (!ragioneSociale) return ''
  if (!codCliente12) return ragioneSociale
  const { mastro, gruppo, conto, sottoConto } = formatClientCode(codCliente12)
  return `${ragioneSociale} (${mastro} ${gruppo} ${conto} ${sottoConto})`
}

export const SearchByClient = ({
  clientCode: [clientCode, setClientCode],
  selectedClient: [selectedClient, setSelectedClient],
  ragioneSociale: [ragioneSociale, setRagioneSociale],
  disabled
}) => {
  const [suggestions, setSuggestions] = useState([])

  const debounceSearchDescrizione = _.debounce(async (event) => {
    const value = event.query.trim()
    if (value.length < 3) return setSuggestions([])
    const { data: suggestions } = await FC.service('info').get('searchClient', {
      query: { ragioneSociale: value }
    })
    setSuggestions(
      suggestions
        .filter(({ datiGeneraliCliente: { ragioneSociale } }) => ragioneSociale)
        .map((client) => ({
          codCliente12: client?.datiGeneraliCliente?.codCliente12,
          ragioneSociale: client?.datiGeneraliCliente?.ragioneSociale,
          label: createClientLabel(
            client?.datiGeneraliCliente?.ragioneSociale,
            client?.datiGeneraliCliente?.codCliente12
          )
        }))
    )
  }, 500)

  return (
    <div className="community-search-panel__block">
      <div className="nfield" style={{ marginBottom: 12 }}>
        <label style={{ fontSize: 13, fontWeight: 600 }}>{t.ricercaCliente}</label>
      </div>
      {noShowFields1a10 &&
        Object.entries(clientCode).map(([key, value], ind) => (
          <InputText
            readOnly={ind === 0}
            disabled={disabled}
            key={ind}
            style={{
              borderRadius: 8,
              marginBottom: 15,
              width: '100%'
            }}
            value={value || ''}
            label={fieldMap?.find(({ id }) => id === key)?.label}
            id={key}
            onChange={(e) => setClientCode({ ...clientCode, [key]: e?.target?.value })}
            keyfilter="int"
            placeholder={fieldMap?.find(({ id }) => id === key)?.label}
          />
        ))}
      <div className="nfield">
        <label>{t.ragioneSociale}</label>
        <AutoComplete
          inputId="ragioneSociale"
          placeholder={t.ragioneSociale}
          inputStyle={{ width: '100%', borderRadius: 8 }}
          style={{ width: '100%' }}
          value={ragioneSociale || ''}
          suggestions={suggestions}
          completeMethod={debounceSearchDescrizione}
          onChange={({ value }) => setRagioneSociale(value)}
          onSelect={({ value }) => {
            setSelectedClient({
              codCliente12: value?.codCliente12,
              ragioneSociale: value?.ragioneSociale
            })
            setClientCode({
              ...clientCode,
              ...formatClientCode(value?.codCliente12)
            })
            setRagioneSociale(value?.ragioneSociale)
          }}
          field="label"
          disabled={disabled}
        />
      </div>
    </div>
  )
}
